module.exports = __webpack_public_path__ + "static/lightning-tooltip-aa19db20d29ec037ec0ed7ca34570a5e.png";